export const LocalStorage = {
    currentPage: "currentPage",
    CURRENT_STEP: "currentStep",
};
